<div 
    class="widget"
    [ngClass]="{
        'active': isSupporter
    }"
    (click)="openSupporterDialog()"
>
    <mat-icon *ngIf="isSupporter" class="info">info</mat-icon>
    <mat-icon>{{ isSupporter ? "check_circle" : "cancel" }}</mat-icon>
    <span class="text">{{"profile.widgets.supporter" | translate }}</span>
</div>